import React, {useEffect, useState} from 'react';
import {IonContent, IonModal, IonPage} from '@ionic/react';
import {useHistory} from 'react-router-dom';

//Google Analytics:
import {getAnalytics, logEvent} from 'firebase/analytics';
import {initializeApp} from "firebase/app";
import {ApiService} from "../api/ApiService";
import {toastStore} from "../components/AppToast";
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { CheckCircleIcon, ChevronLeft, HistoryIcon, XCircleIcon } from '../components/icons';

var moment = require('moment');

let mustWatch = false;

interface AdvanceHistory {
    date: string,
    amount: string,
    status: string
}

function statusClass(status: string) {
  if (status === 'approved') return 'advance-current__status--approved';
  if (status === 'pending') return 'advance-current__status--pending';
  return 'advance-current__status--other';
}

const PersonalAdvance: React.FC = () => {
    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [reason, setReason] = useState<string>();
    const [showHistory, setShowHistory] = useState(false)
    const [advanceAmount, setAdvanceAmount] = useState<number>();
    const [available, setAvailable] = useState<string>();
    const [showModal, setShowModal] = useState(mustWatch);
    const [advances, setAdvances] = useState<AdvanceHistory[]>([]);
    const [watchedVid, setWatchedVid] = useState(false);
    const [moneyAvailable, setMoneyAvailable] = useState(false);
    const [isDispatched, setIsDispatched] = useState(false);
    const [hasPaperwork, setHasPaperwork] = useState(false);
    const [owesWestern, setOwesWestern] = useState(false);
    const [videoLink, setVideoLink] = useState('');

    const firebaseConfig = {
        apiKey: "AIzaSyDE8xEN_qtMPO-aBkTon7S7kKcyUZJD5gc",
        authDomain: "western-express-5002c.firebaseapp.com",
        databaseURL: "https://western-express-5002c.firebaseio.com",
        projectId: "western-express-5002c",
        storageBucket: "western-express-5002c.appspot.com",
        messagingSenderId: "799211811572",
        appId: "1:799211811572:web:34706f63a8621cb0b0a4a1",
        measurementId: "G-V5MNJV768B"
    }

    const app = initializeApp(firebaseConfig)

    const handleEventLog = (eventType: string, info: string) => {
        const analytics = getAnalytics(app);
        logEvent(analytics, eventType, {eventType: info})
    }

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.getVideosList('personalAdvance', {type: 'other'}).then(it => setVideoLink(it.find(video => video.title === 'Cash Advance Video')?.youtube!));
        if (advances?.length === 0) {
            ApiService.getCashAdvances('personalAdvance',).then(it => {
                setAdvances(it.map(advance => {
                    return {
                        date: moment(advance.date).format('M/D/YYYY'),
                        amount: advance.amount,
                        status: advance.status
                    }
                }));
            });
        }
        ApiService.getCashAdvanceEligibility('personalAdvance',).then(it => {
            setMoneyAvailable(parseFloat(it.available) > 0);
            setAvailable(it.available);
            setIsDispatched(!it.notDispatched);
            setHasPaperwork(!it.paperworkIncomplete);
            setOwesWestern(it.owing);
        });

        // Forced Video
        let last_watched = localStorage.getItem('lastwatchedadvance')
        if (last_watched) {
            // If true: the video has been watched in the last 24 hours
            if ((new Date().getTime() - new Date(last_watched).getTime()) < 86400000) {
                mustWatch = false
                return
            }
        }
        if (watchedVid) {
            let string = new Date()
            localStorage.setItem('lastwatchedadvance', string.toString())
        } else {
            mustWatch = true
            setShowModal(mustWatch)
        }
    }, [watchedVid]);

    async function submitRequest() {
        ApiService.sendEventCommand('Request Advance', 'eventCheck', 'User requested an advance');
        ApiService.submitCashAdvance('personalAdvance', {amount: advanceAmount!, comment: reason!}).then(() => {
            toastStore.getState().setSuccessToast('Your advance has been requested.');
        });
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Home');
    };

    const isBlocked = owesWestern || !hasPaperwork || !available || !isDispatched;
    const current = advances[0];

    return (
        <IonPage>
            <LoadDetailHeader title="Personal Advance" onBack={goBack} onSheet={onSheet} />

            <IonModal
              isOpen={showModal}
              cssClass="safety-video-modal"
              onDidDismiss={() => setShowModal(false)}
            >
              <div className="safety-media-modal">
                <div className="safety-media-modal__header">
                  <button type="button" className="safety-media-modal__back" onClick={() => setShowModal(false)}>
                    <ChevronLeft size={20} />
                    Back
                  </button>
                  <div className="safety-media-modal__title">Please watch this brief video before continuing</div>
                </div>
                <div className="safety-media-modal__body safety-media-modal__body--video">
                  <iframe
                    className="safety-media-modal__iframe"
                    src={"https://www.youtube.com/embed/" + videoLink}
                    title="video"
                    onEnded={function () {
                        mustWatch = false;
                        setWatchedVid(true);
                        setShowModal(false)
                    }}
                  />
                </div>
              </div>
            </IonModal>

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero advance-hero">
                  <div className="advance-hero__eyebrow">Payroll</div>
                  <div className="advance-hero__title home-display">Personal Advance</div>
                  <div className="advance-hero__meta">
                    {moneyAvailable ? (
                      <>Up to <span className="advance-hero__amount">{`$${available}`}</span> available</>
                    ) : 'Check eligibility below'}
                  </div>
                </div>

                <div className="home-sheet advance-sheet">
                  <div className="advance-card">
                    <div className="advance-card__title">New request</div>
                    {current ? (
                      <div className="advance-current">
                        <div className="advance-current__amount">${current.amount}</div>
                        <div className={`advance-current__status ${statusClass(current.status)}`}>
                          Status: {current.status}
                        </div>
                      </div>
                    ) : (
                      <p className="advance-card__body">You do not have any active requests.</p>
                    )}

                    {showHistory ? (
                      <div className="advance-history">
                        <button type="button" className="advance-history-toggle" onClick={() => setShowHistory(false)}>
                          <HistoryIcon size={16} color="oklch(0.55 0.01 260)" />
                          Show less
                        </button>
                        {advances.map((adv, index) => (
                          <div key={`${adv.date}-${index}`} className="advance-history__row">
                            <div>
                              <div className="advance-history__amount">${adv.amount}</div>
                              <div className="advance-history__date">{adv.date}</div>
                            </div>
                            <div className={`advance-history__status advance-current__status ${statusClass(adv.status)}`}>
                              {adv.status}
                            </div>
                          </div>
                        ))}
                        <p className="advance-history__meta">
                          Showing {advances.length} result{advances.length === 1 ? '' : 's'}.
                        </p>
                      </div>
                    ) : (
                      <button type="button" className="advance-history-toggle" onClick={() => setShowHistory(true)}>
                        <HistoryIcon size={16} color="oklch(0.55 0.01 260)" />
                        See history
                      </button>
                    )}
                  </div>

                  <div className="advance-card">
                    <div className="advance-card__title">Am I eligible for an advance?</div>
                    <div className="advance-checks">
                      <div className="advance-check">
                        <span className="advance-check__label">
                          {moneyAvailable
                            ? `You have up to $${available} available for advance.`
                            : 'You have $0 available for advance.'}
                        </span>
                        {moneyAvailable ? <CheckCircleIcon /> : <XCircleIcon />}
                      </div>
                      <div className="advance-check">
                        <span className="advance-check__label">
                          {isDispatched ? 'You are dispatched' : 'You are not dispatched'}
                        </span>
                        {isDispatched ? <CheckCircleIcon /> : <XCircleIcon />}
                      </div>
                      <div className="advance-check">
                        <span className="advance-check__label">
                          {hasPaperwork ? 'You are up to date on your paperwork.' : 'You are not up to date on your paperwork.'}
                        </span>
                        {hasPaperwork ? <CheckCircleIcon /> : <XCircleIcon />}
                      </div>
                      <div className="advance-check">
                        <span className="advance-check__label">
                          {!owesWestern ? 'You are not in the owing position.' : 'You are in the owing position.'}
                        </span>
                        {!owesWestern ? <CheckCircleIcon /> : <XCircleIcon />}
                      </div>
                    </div>

                    <div className="profile-fields">
                      <label className="profile-field">
                        <span className="profile-field__label">Reason (optional)</span>
                        <input
                          className="profile-field__input"
                          id="reason"
                          type="text"
                          disabled={isBlocked}
                          value={reason || ''}
                          onChange={e => setReason(e.target.value)}
                        />
                      </label>
                      <label className="profile-field">
                        <span className="profile-field__label">Amount</span>
                        <input
                          className="profile-field__input"
                          id="amount"
                          type="number"
                          disabled={isBlocked}
                          value={advanceAmount ?? ''}
                          onChange={e => setAdvanceAmount(parseFloat(e.target.value))}
                        />
                      </label>
                      <p className="advance-note">If approved, this advance will be deducted from your paycheck.</p>
                      <button
                        type="button"
                        id="western-button-submit"
                        className="profile-submit"
                        disabled={isBlocked}
                        onClick={() => {
                          submitRequest();
                          handleEventLog("advance_PayRequest", "submit-PayRequest")
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </IonContent>
        </IonPage>
    );
};

export default PersonalAdvance;
